<mat-button-toggle-group class="tenant-menu w-100" vertical (change)="onTenantSelected($event)" [value]="currentTenant">
	@for(tenant of (tenants | async); track tenant){
		<mat-button-toggle class="no-borders" [value]="tenant.code">{{ tenant.name }}</mat-button-toggle>
    }
</mat-button-toggle-group>
